export const BaseResponseCount = 23134; // Total number of responses to scale from 